import { Base } from '@studiometa/js-toolkit';

/**
 * Post
 */
export default class Post extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Post',
    refs: ['picture'],
  };

  /**
   * Set Insta attributs to cards
   * @param {string} url instagram post link.
   * @param {string} picture_url instagram picture url.
   */
  setInstaData(url, picture_url) {
    this.$refs.picture.src = picture_url;
    this.$el.href = url;
    this.$el.classList.remove('opacity-0');
  }
}
